import * as types from '../actiontypes';
import env from '../../util/env';
import {serviceURL} from '../../util/uiconstants';

export const createEntityForm = (engagementId, data, source) => {
	const url = `${env.getBaseURL(serviceURL, engagementId)}EntityForms`;
	return {
		type: types.CREATE_ENTITY_FORM,
		meta: {
			api: {
				url,
				method: 'POST',
				data
			}
		},
		objectIds: data.objectIds,
		documentTypeId: data.documentTypeId,
		source
	};
};
